module.exports = __webpack_public_path__ + "img/thumbnail_BlackWildebeest_f_albino.9e8ea599.png";